<script lang="ts">
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { reformatUrlAndGetTargetValue } from "@shared/services/target_value_forward_urls";
  import { EventTracking } from "@shared/services/event_tracking/events";

  const { trackClick } = EventTracking;

  export let logoProps: Record<string, any> = {};
  export let forwardLink: string = "";

  const { href, target } = reformatUrlAndGetTargetValue(forwardLink);
</script>

<style>
  .logo-image-container {
    overflow: hidden;
    border-radius: 0.25rem;
    flex-shrink: 0;
    border: 1px solid #eaeaea;
    align-self: start;
    justify-self: start;
    width: 58px;
    height: 58px;
  }
  .logo-image-container > img {
    aspect-ratio: 1/1;
    height: 56px;
    width: 56px;
  }

  a {
    display: grid;
  }
</style>

<TrackingContext let:trackingContext>
  <a
    {href}
    {target}
    on:click={() => trackClick("shoppable_unit_logo_image", trackingContext.entities)}
  >
    <picture class="logo-image-container">
      <img data-testid="shoppable-unit-logo-image" src={logoProps.src} alt={logoProps.alt} />
    </picture>
  </a>
</TrackingContext>
